import { handleActions } from 'redux-actions';
import { logoutSuccess } from 'ducks/auth/actions';
import { setBranchID } from './actions';

import initialState from './states';

export default handleActions(
  {
    [logoutSuccess]() {
      return {
        ...initialState,
      };
    },
    [setBranchID](state, { payload: branchID }) {
      return {
        ...state,
        branchID,
      };
    },
  },
  initialState
);
